<template>
  <div class="app">
    <v-dialog
      v-model="dialogDetailCarte"
      max-width="70%"
      persistent
      fullscreen
      hide-overlay
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span> Detail de la carte carburant {{ carte.identifiant }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-flex xs3 class="mr-3">
              <v-card>
                <v-list two-line>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon large color="indigo">info</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title class="green--text"
                        >{{ carte.totalCrediter }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >Total credité (Fcfa)</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="indigo"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title class="red--text">{{
                        carte.totalDebiter
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Total debité (Fcfa)</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="indigo"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title class="blue--text">{{
                        carte.montantFormat
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Solde actuel (Fcfa)</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>

            <v-flex xs8>
              <v-card flat>
                <v-card-text>
                  <v-flex xs12>
                    <v-layout row>
                      <v-flex xs6 class="mr-4">
                        <!--COLONNE 1-->
                        <v-layout row>
                          <v-flex xs6>IDENTIFIANT</v-flex>
                          <v-flex xs6 class="text-xs-right title orange--text">
                            {{ carte.identifiant }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>LIBELLE</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.libelle }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>FOURNISSEUR</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.station }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>ZONE CONCERNEE</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.zone }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>RESPONSABLE</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.responsable }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                      </v-flex>

                      <v-flex xs6 class="ml-1">
                        <!--COLONNE 2-->

                        <v-layout row>
                          <v-flex xs6>DATE DE CREATION</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.dateCreated }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>ENREGISTRE PAR</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.userCreated }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>MODIFIE PAR</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ carte.userEdited }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                        <v-layout wrap>
                          <v-flex xs6>Description</v-flex>
                          <v-flex xs12 class="text-xs-right title">
                            <v-text-field
                              disabled
                              :value="carte.description"
                              label=""
                              placeholder=""
                              outline
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!--TABS-->
          <v-layout row class="mt-4">
            <Loading :value="loading"></Loading>
            <v-flex xs12>
              <el-tabs
                @tab-click="handleClick"
                type="border-card"
                v-model="activeName"
              >
                <el-tab-pane label="Approvisionnement" name="appro">
                  <h6>LISTE DES APPROVISIONNEMENTS</h6>
                  <v-divider class="mb-3"></v-divider>
                  <v-layout row>
                    <v-flex class="mb-1 " xs4 md4>
                      <v-card-text class="">
                        <v-chip
                          color="orange"
                          text-color="white"
                          style="font-size:18px"
                        >
                          <v-avatar class="orange darken-4">{{
                            rechargementsValider.length
                          }}</v-avatar>
                          Approvisionnement(s)
                        </v-chip>
                      </v-card-text>
                    </v-flex>
                  </v-layout>

                  <data-tables :data="rechargementsValider">
                    <el-table-column prop="created" label="Enregistré le ">
                    </el-table-column>
                    <el-table-column prop="carteCible" label="Carte à crediter">
                      <template slot-scope="scope">
                        <el-tag>{{ scope.row.carteCible }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="carteSource" label="Carte à debiter">
                      <template slot-scope="scope">
                        <el-tag v-show="scope.row.carteSource" type="danger">{{
                          scope.row.carteSource
                        }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="montantFormat"
                      label="Montant (Fcfa)"
                    >
                      <template slot-scope="scope">
                        <el-tag v-show="scope.row.montantFormat" type="info">{{
                          scope.row.montantFormat
                        }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="libStatut"
                      label="Statut"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.statut == 1" type="danger">{{
                          scope.row.libStatut
                        }}</el-tag>
                        <el-tag v-if="scope.row.statut == 2" type="info">
                          {{ scope.row.libStatut }}</el-tag
                        >
                        <el-tag v-if="scope.row.statut == 3" type="success">{{
                          scope.row.libStatut
                        }}</el-tag>
                        <el-tag v-if="scope.row.statut == 4" type="warning">{{
                          scope.row.libStatut
                        }}</el-tag>
                        <el-tag v-if="scope.row.statut == 5">{{
                          scope.row.libStatut
                        }}</el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="dateValidation"
                      label="Date de validation"
                    ></el-table-column>
                    <el-table-column
                      prop="validateur"
                      label="Validé par"
                    ></el-table-column>
                    <el-table-column
                      prop="userCreated"
                      label="Appro Effectué par"
                    ></el-table-column>

                    <el-table-column
                      label="Action"
                      align="center"
                      fixed="right"
                      width="180"
                    >
                      <template slot-scope="scope">
                        <v-tooltip top>
                          <!-- <v-btn v-if="scope.row.statut == 5 && droitAcces.valide_appro"  slot="activator" @click="modalAppro(scope.row)"  fab dark small color="green"> -->
                          <v-btn
                            v-if="scope.row.statut == 5"
                            slot="activator"
                            @click="modalAppro(scope.row)"
                            fab
                            dark
                            small
                            color="green"
                          >
                            <v-icon dark>done</v-icon>
                          </v-btn>
                          Valider l'Approvisionnement
                        </v-tooltip>

                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            v-if="scope.row.statut == 3 && scope.row.imageRecu"
                            @click.stop="imprimerRecu(scope.row.imageRecu)"
                            fab
                            dark
                            icons
                            small
                            color="cyan"
                          >
                            <v-icon dark>photo</v-icon>
                          </v-btn>
                          Pièce jointe
                        </v-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables>
                </el-tab-pane>

                <el-tab-pane label="Achat" name="achat">
                  <h6>LISTE DES ACHATS</h6>
                  <v-divider class="mb-3"></v-divider>
                  <v-layout row>
                    <v-flex class="mb-1 " xs4 md4>
                      <v-card-text class="">
                        <v-chip
                          color="orange"
                          text-color="white"
                          style="font-size:18px"
                        >
                          <v-avatar class="orange darken-4">{{
                            achats.length
                          }}</v-avatar>
                          Achat(s)
                        </v-chip>
                      </v-card-text>
                    </v-flex>
                  </v-layout>
                  <data-tables :data="achats">
                    <el-table-column prop="dateCreated" label="Date">
                    </el-table-column>
                    <el-table-column
                      prop="station"
                      label="Station"
                    ></el-table-column>
                    <el-table-column
                      prop="quantite"
                      label="Quantité"
                    ></el-table-column>
                    <el-table-column
                      prop="montantFormat"
                      label="Montant (Fcfa)"
                    >
                      <template slot-scope="scope">
                        <el-tag v-show="scope.row.montantFormat" type="info">{{
                          scope.row.montantFormat
                        }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="vehicule"
                      label="vehicule"
                    ></el-table-column>
                    <el-table-column
                      prop="createdUser"
                      label="Enregistré par"
                    ></el-table-column>
                  </data-tables>
                </el-tab-pane>

                <el-tab-pane label="Transfert" name="transfert">
                  <el-row type="flex" class="row-bg">
                    <el-col :span="18"><div></div></el-col>
                    <el-col :span="6">
                      <div style="text-align:right">
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            color="primary"
                            @click.stop="modalAjoutTransfert()"
                            dark
                          >
                            Transfert
                            <v-icon center>add</v-icon>
                          </v-btn>
                          Effectuer une demande de transfert
                        </v-tooltip>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="11">
                      <el-card shadow="always">
                        <div>
                          <h6>LISTE DES TRANSFERTS EMIS</h6>
                          <v-divider class="mb-3"></v-divider>
                          <!-- BTN AJOUT -->
                          <v-layout row>
                            <v-flex class="mb-1 " xs4 md4>
                              <v-card-text class="">
                                <v-chip
                                  color="orange"
                                  text-color="white"
                                  style="font-size:18px"
                                >
                                  <v-avatar class="orange darken-4">{{
                                    rechargementsEmis.length
                                  }}</v-avatar>
                                  Transfert(s)
                                </v-chip>
                              </v-card-text>
                            </v-flex>
                          </v-layout>
                          <data-tables :data="rechargementsEmis">
                            <el-table-column
                              prop="created"
                              label="Enregistré le"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="carteCible"
                              label="Carte creditée"
                              width="170"
                            >
                              <template slot-scope="scope">
                                <el-tag
                                  v-show="scope.row.carteCible"
                                  type="success"
                                  >{{ scope.row.carteCible }}</el-tag
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="montantFormat"
                              label="Montant(Fcfa)"
                            >
                              <template slot-scope="scope">
                                <el-tag
                                  v-show="scope.row.montantFormat"
                                  type="info"
                                  >{{ scope.row.montantFormat }}</el-tag
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="libStatut"
                              label="Statut"
                              width="170"
                            >
                              <template slot-scope="scope">
                                <el-tag
                                  v-if="scope.row.statut == 0"
                                  type="danger"
                                  >{{ scope.row.libStatut }}</el-tag
                                >
                                <el-tag
                                  v-if="scope.row.statut == 1"
                                  type="warning"
                                >
                                  {{ scope.row.libStatut }}</el-tag
                                >
                                <el-tag
                                  v-if="scope.row.statut == 2"
                                  type="info"
                                  >{{ scope.row.libStatut }}</el-tag
                                >
                                <el-tag
                                  v-if="scope.row.statut == 3"
                                  type="success"
                                  >{{ scope.row.libStatut }}</el-tag
                                >
                                <el-tag
                                  v-if="scope.row.statut == 4"
                                  type="warning"
                                  >{{ scope.row.libStatut }}</el-tag
                                >
                                <el-tag v-if="scope.row.statut == 5">{{
                                  scope.row.libStatut
                                }}</el-tag>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="validateur"
                              label="Validé par"
                              width="170"
                            ></el-table-column>
                            <el-table-column
                              prop="dateValidation"
                              label="Date de validation"
                              width="170"
                            ></el-table-column>
                          </data-tables>
                        </div>
                      </el-card>
                    </el-col>

                    <el-col :span="12">
                      <el-card shadow="always">
                        <div>
                          <h6>LISTE DES TRANSFERTS DE CARTE RECUS</h6>
                          <v-divider class="mb-3"></v-divider>
                          <!-- BTN AJOUT -->
                          <v-layout row>
                            <v-flex class="mb-1 " xs4 md4>
                              <v-card-text class="">
                                <v-chip
                                  color="orange"
                                  text-color="white"
                                  style="font-size:18px"
                                >
                                  <v-avatar class="orange darken-4">{{
                                    rechargementsRecus.length
                                  }}</v-avatar>
                                  Transfert(s)
                                </v-chip>
                              </v-card-text>
                            </v-flex>
                          </v-layout>
                          <data-tables :data="rechargementsRecus">
                            <el-table-column
                              prop="created"
                              label="Enregistré le"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="carteSource"
                              label="Carte debitée"
                            >
                              <template slot-scope="scope">
                                <el-tag
                                  v-show="scope.row.carteSource"
                                  type="danger"
                                  >{{ scope.row.carteSource }}</el-tag
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="montantFormat"
                              label="Montant(Fcfa)"
                            >
                              <template slot-scope="scope">
                                <el-tag
                                  v-show="scope.row.montantFormat"
                                  type="info"
                                  >{{ scope.row.montantFormat }}</el-tag
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="zone"
                              label="Zone de la carte"
                            ></el-table-column>
                            <el-table-column
                              prop="validateur"
                              label="Validé par"
                            ></el-table-column>
                            <el-table-column
                              prop="dateValidation"
                              label="Date de validation"
                            ></el-table-column>
                          </data-tables>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                  <v-divider class="mb-4 mt-4"></v-divider>

                  <el-row>
                    <el-col :span="24">
                      <el-card shadow="always">
                        <h6>LISTE DES TRANSFERTS EN ATTENTE</h6>
                        <v-divider class="mb-3"></v-divider>
                        <!-- BTN AJOUT -->
                        <v-layout row>
                          <v-flex class="mb-1 " xs4 md4>
                            <v-card-text class="">
                              <v-chip
                                color="orange"
                                text-color="white"
                                style="font-size:18px"
                              >
                                <v-avatar class="orange darken-4">{{
                                  rechargementsAttente.length
                                }}</v-avatar>
                                Carte(s)
                              </v-chip>
                            </v-card-text>
                          </v-flex>
                        </v-layout>

                        <data-tables :data="rechargementsAttente">
                          <el-table-column prop="created" label="Date">
                          </el-table-column>
                          <el-table-column
                            prop="carteSource"
                            label="Carte concernée"
                          >
                            <template slot-scope="scope">
                              <el-tag
                                v-show="scope.row.carteSource"
                                type="warning"
                                >{{ scope.row.carteSource }}</el-tag
                              >
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="montantFormat"
                            label="Montant(Fcfa)"
                          >
                            <template slot-scope="scope">
                              <el-tag
                                v-show="scope.row.montantFormat"
                                type="info"
                                >{{ scope.row.montantFormat }}</el-tag
                              >
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="createdUser"
                            label="Initiateur"
                          ></el-table-column>
                          <el-table-column
                            label="Action"
                            align="center"
                            fixed="right"
                          >
                            <template slot-scope="scope">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  @click.stop="modalValideTransfert(scope.row)"
                                  fab
                                  dark
                                  small
                                  color="green"
                                >
                                  <v-icon dark>done</v-icon>
                                </v-btn>
                                Valider ou rejeter le transfert
                              </v-tooltip>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </el-card>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDATION APPRO -->
    <v-dialog v-model="dialogAddAppro" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline"
          >Voulez-vous approvisionner la carte
          {{ carte.identifant }} ?</v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="Confirmation d'un approvisionnement"
                description="Après la validation, l'approvisionnement ne pourra pas etre modifié, ni supprimé ."
                :closable="false"
                show-icon
                type="warning"
              >
              </el-alert>
            </v-flex>
            <v-flex xs12>
              <el-form
                id="formFiche"
                :model="formFiche"
                :rules="ruleFiche"
                ref="formFiche"
                class="demo-form-inline"
              >
                <el-form-item label="Montant" prop="montant">
                  <!-- <el-input-number :disabled="carteTransfert"  :min="1"  v-model="formFiche.montant" name="montant" placeholder="saisir un montant"  style="width: 100%"></el-input-number> -->
                  <el-input-number
                    :disabled="true"
                    :min="1"
                    v-model="formFiche.montant"
                    name="montant"
                    placeholder="saisir un montant"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>

                <el-form-item>
                  <v-flex xs12 class="mr-1">
                    <v-avatar
                      :tile="true"
                      size="140px"
                      height="120px"
                      color="grey lighten-4"
                    >
                      <img :src="image1" alt="avatar"
                    /></v-avatar>
                    <v-layout row>
                      <input
                        name="image1"
                        type="file"
                        style="display:none"
                        ref="file1"
                        accept="image/*"
                        @change="onFileImage1Picked"
                      />
                      <v-btn
                        color="primary"
                        class="white--text"
                        required
                        @click.native="$refs.file1.click()"
                        >Pièce jointe
                        <v-icon right dark>cloud_upload</v-icon></v-btn
                      >
                      <div class="font-weight-thin">
                        Fichier au format (JPEG,PNG,PDF) avec une taille de 1048
                        ko maximale
                      </div>
                    </v-layout>
                  </v-flex>
                </el-form-item>
              </el-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="dialogAddAppro = false"
            >Annuler <v-icon right>remove_circle</v-icon></v-btn
          >
          <v-btn color="green darken-1" dark @click="submitAppro('formFiche')"
            >Confirmer <v-icon right>done_all</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDATION TRANSFERT -->
    <v-dialog v-model="dialogValideTransfert" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline"
          >Voulez-vous valider ou rejeter le transfert de la carte
          {{ carte.identifant }} ?</v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="Confirmation d'un transfert"
                :description="
                  'Après la validation, le transfert ne pourra pas être modifié, ni supprimé, Veuillez confirmer  le montant suivant:  ' +
                    montantTransfert +
                    ' Fcfa'
                "
                :closable="false"
                show-icon
                type="warning"
              >
              </el-alert>
            </v-flex>
            <v-flex xs12>
              <el-form ref="formFiche" class="demo-form-inline">
                <el-form-item style="width:100%" label="Motif du rejet">
                  <el-input
                    style="width:100%"
                    type="textarea"
                    :rows="6"
                    placeholder="Pourquoi voulez-vous rejeter le tranfert ?"
                    v-model="motifRejetTransfert"
                  ></el-input>
                </el-form-item>
              </el-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            @click="dialogValideTransfert = false"
            >Annuler <v-icon right>remove_circle</v-icon></v-btn
          >
          <v-btn
            color="red darken-1"
            class="white--text"
            :disabled="motifRejetTransfert == ''"
            @click="submitValideTransfert('refuser')"
            >Rejeter <v-icon right>done_all</v-icon></v-btn
          >
          <v-btn
            color="green darken-1"
            dark
            @click="submitValideTransfert('valider')"
            >Valider <v-icon right>done_all</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ajout transfert -->
    <AjoutTransfertCarte
      :editRecharge="editTransfert"
      :carte="carte"
      :show="showModalAjoutTransfert"
      @close="
        showModalAjoutTransfert = false;
        loadTransfertEmis();
      "
    ></AjoutTransfertCarte>
    <!-- Ajout transfert -->
  </div>
</template>

<script>
import AjoutTransfertCarte from "./AjoutTransfertCarte";
import Loading from "@/components/Loading";
export default {
  components: { Loading, AjoutTransfertCarte },
  name: "FicheDetailCarte",
  props: {
    carte: {
      type: Object,
      default: {}
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],

      //rechargements
      dialogSupr: false,
      dialogDetailCarte: false,
      rechargementsValider: [],
      oldRechargementsValider: [],
      formFiche: {},
      ruleFiche: {
        montant: [{ required: true, message: "Veuillez saisir" }]
      },
      dialogAddAppro: false,
      rechargeSelect: null,
      carteTransfert: false, // false=>espece // true=>carte
      image1: "/static/img-doc.png",
      file1: "",
      //Emis

      //achats
      achats: [],
      oldAchat: [],
      rechargementsEmis: [],
      oldRechargementsEmis: [],
      rechargementsRecus: [],
      rechargementsAValider: [],

      //Transfert
      transferts: [],
      oldTransferts: [],
      showModalAjoutTransfert: false,
      editTransfert: {},
      rechargementsAttente: [],
      oldRechargementsAttente: [],
      nbRechargeAttente: 0,
      dialogValideTransfert: false,
      montantTransfert: 0,
      motifRejetTransfert: "",
      rechargeId: null,
      activeName: "appro"
    };
  },

  watch: {
    show: function(newValue, oldValue) {
      this.dialogDetailCarte = newValue;
      if (newValue == true) {
        this.activeName = "appro";
        this.rechargementsEmis.splice(0);
        this.rechargementsRecus.splice(0);
        this.rechargementsAValider.splice(0);
        this.loadRechargementValider();
      }
    }
  },

  methods: {
    handleClick(tab, clicked) {
      let idTab = clicked.target.id;

      switch (idTab) {
        case "tab-appro": //appro
          this.loadRechargementValider();
          break;

        case "tab-achat": //achat
          this.loadAchat();
          break;

        case "tab-transfert": //transfert
          this.loadTransfertEnAttente();
          this.loadTransfertRecu();
          this.loadTransfertEmis();
          break;
      }
    },

    //enregistrement des images
    onFileImage1Picked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.image1 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file1 = files[0];
    },

    modalAppro(recharge) {
      // if(recharge.carteSource){
      //     this.carteTransfert = true;
      //     this.formFiche.montant = recharge.montant;

      // }
      // else {
      //     this.carteTransfert = false;
      this.formFiche.montant = recharge.montant;
      this.image1 = "";
      //}
      this.rechargeSelect = recharge.id;
      this.dialogAddAppro = true;
    },
    submitAppro(formName) {
      if (this.file1 == "") {
        this.$message.error("Veuillez selectionner une piece jointe");
        return;
      }

      this.loading = true;
      let form = document.getElementById("formFiche");
      //recuperation des demandes
      let data = new FormData(form);
      let url = this.domaine + "carteCarburant/valide/approvisionnement";

      data.append("userId", this.user.id);
      data.append("idRecharge", this.rechargeSelect);
      data.append("montant", this.formFiche.montant);

      this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire
          //revoir les montants afficher dont le solde et les montant crediter dans l'affichage
          this.file1 = "";
          this.loading = false;
          this.dialogAddAppro = false;
          this.resetForm("formFiche");
          this.successNotif(response.body.message);
          this.loadRechargementValider();
        },
        erreur => {
          //reinitialiser le formulaire
          this.loading = false;
          this.resetForm("formFiche");
          this.dialogAddAppro = false;
          this.$message.error(
            "Une erreur est survenue lors de l'enregistrement de l'approvisionnement'"
          );
          this.loadRechargementValider();
        }
      );
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    successNotif(mess = "", title = "'ENREGISTREMENT REUSSI") {
      this.$notify({
        title: "",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },

    showDialogSupp(item) {
      // this.carteId = item.carteId
      // this.dialogSupr = true;
    },
    closeDialog() {
      this.$emit("close");
    },
    loadTransfertEnAttente() {
      this.loading = true;
      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)
      let url =
        this.domaine +
        "carteCarburant/rechargeEnAttente/carte/" +
        this.carte.carteId;

      this.$http.get(url).then(
        response => {
          this.loading = false;
          // this.mntTTC =  response.body.mntTTC
          this.rechargementsAttente = response.body.transferts;
          this.oldRechargementsAttente = response.body.transferts;

          //this.mntTotal = response.body.montantTotalFormat
          //affichage nombre de demande
          this.nbRechargeAttente = this.rechargementsAttente.length;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Veuillez patienter, le chargements des teansferts en attente..."
          );
        }
      );
    },
    loadRechargementValider() {
      this.loading = true;
      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)
      let url =
        this.domaine +
        "carteCarburant/valide/rechargements/carte/" +
        this.carte.carteId;

      this.$http.get(url).then(
        response => {
          this.loading = false;
          // this.mntTTC =  response.body.mntTTC
          this.rechargementsValider = response.body.transferts;
          this.oldRechargementsValider = response.body.transferts;

          //this.mntTotal = response.body.montantTotalFormat
          //affichage nombre de demande
          this.nbRecharge = this.rechargementsValider.length;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Veuillez patienter, le chargements des approvisonnements en cours..."
          );
        }
      );
    },
    loadTransfertRecu() {
      let carte = this.carte;
      this.rechargementsRecus = this.oldRechargementsValider.filter(function(
        item
      ) {
        if (
          item.carteSource != "" &&
          item.carteCible == carte.identifiant &&
          item.statut == 3
        ) {
          //carte deja valider
          return item;
        }
      });
    },
    loadTransfertEmis() {
      this.loading = true;
      let url =
        this.domaine +
        "carteCarburant/rechargements/emis/" +
        this.carte.carteId;

      this.$http.get(url).then(
        response => {
          this.loading = false;
          // this.mntTTC =  response.body.mntTTC
          this.rechargementsEmis = response.body.transferts;
          this.oldRechargementsEmis = response.body.transferts;

          //this.mntTotal = response.body.montantTotalFormat
          //affichage nombre de demande
          //this.nbRecharge = this.rechargementsValider.length
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Veuillez patienter, le chargements des transfert emis est en cours..."
          );
        }
      );
    },

    loadAchat() {
      this.loading = true;
      let url =
        this.domaine + "carteCarburant/achat/cartes/" + this.carte.carteId;

      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.achats = response.body.achats;
          this.oldAchats = response.body.achats;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Veuillez patienter, le chargements des achats est en cours..."
          );
        }
      );
    },
    modalAjoutTransfert() {
      this.showModalAjoutTransfert = true;
    },
    modalValideTransfert(item) {
      this.montantTransfert = item.montantFormat;
      this.rechargeId = item.id;
      this.dialogValideTransfert = true;
    },
    submitValideTransfert(decision) {
      let data = new FormData();

      let url = "";
      if (decision == "refuser") {
        if (this.motifRejetTransfert == "") {
          this.$message.error(
            "Veuillez saisir une brève description qui justifie le rejet de ce transfert"
          );
          return;
        }
        url = this.domaine + "carteCarburant/refuser/recharge";
        data.append("refus", this.motifRejetTransfert);
      } else if (decision == "valider") {
        url = this.domaine + "carteCarburant/valider/recharge";
      }
      this.loading = true;

      data.append("rechargeId", this.rechargeId);
      data.append("userId", this.user.id);

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)
      //url = this.domaine +  'carteCarburant/rechargeEnAttente/carte/'+this.carte.carteId

      this.$http.post(url, data).then(
        response => {
          this.dialogValideTransfert = false;
          this.loading = false;
          this.successNotif(response.body.message, "CONFIRMATION TRANSFERT");
          this.loadTransfertEnAttente();
        },
        response => {
          this.dialogValideTransfert = false;
          this.loading = false;
          this.$message.error(
            "Une erreur s'est produite lors de la confirmation du transfert"
          );
        }
      );
    },
    successNotif(mess = "", title = "ENREGISTREMENT REUSSI") {
      this.$notify({
        title: this.title,
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    //impression de limage du recu
    imprimerRecu(urlImageRecu) {
      window.open(urlImageRecu);
    }
  },

  mounted() {
    //this.loadCarte();
  }
};
</script>

<style scoped>
.toolbar_content {
  height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/FicheDetailCarte.vue